import {
    FormOutlined,
    ClockCircleOutlined,
    SendOutlined,
} from '@ant-design/icons'
import { Row, Col, Modal, notification } from 'antd'
import { Form, Input, Button } from 'antd'
import './help.scss'
import { VALIDATIONS } from '../../utils/Validations'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const Help = () => {
    const navigate = useNavigate()
    const [isModalOpen, setIsModalOpen] = useState(true)
    const [submitting, setSubmitting] = useState(false)
    const [form] = Form.useForm()

    const onFinish = async (values) => {
        // Show success locally without calling any API
        setSubmitting(true)
        try {
            await new Promise((res) => setTimeout(res, 350))
            notification.success({
                message: 'Request Sent',
                description: 'Support request submitted. We will get back to you soon.',
                placement: 'topRight',
            })
            form.resetFields()
            form.setFieldsValue({
                name: '',
                email: '',
                organization: '',
                subject: '',
                description: '',
            })
        } finally {
            setSubmitting(false)
        }
    }

    const handleCancel = () => {
        setIsModalOpen(false)
        navigate('/')
    }

    return (
        <div className="modalContent">
            <Modal
                className="modalBody"
                open={isModalOpen}
                footer={null}
                width={980}
                onCancel={handleCancel}
                getContainer={false}
                bodyStyle={{ padding: 0 }}
                maskStyle={{ backgroundColor: 'rgba(16, 24, 40, 0.72)' }}
            >
                <div className="parentBody">
                    <div className="container">
                        <div className="icon">
                            <FormOutlined />
                        </div>
                        <div className="headingBody">
                            <h2>Alectify Support</h2>
                            <p>
                                Need help with the Alectify app? Contact our support team using the form below. We will respond as soon as possible.
                            </p>
                        </div>

                        <div className="supportCards">
                            <div className="supportCard singleCard">
                                <div className="cardIcon">
                                    <ClockCircleOutlined />
                                </div>
                                <div className="cardContent">
                                    <span>Support Hours</span>
                                    <strong>
                                        Monday – Friday, 9:00 AM – 6:00 PM PST
                                    </strong>
                                </div>
                            </div>
                        </div>

                        <Form
                            form={form}
                            layout="vertical"
                            name="support"
                            onFinish={onFinish}
                            autoComplete="off"
                        >
                            <Row gutter={[8]}>
                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        name="name"
                                        label="Full Name"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please enter your full name.',
                                            },
                                            {
                                                pattern:
                                                    VALIDATIONS.name
                                                        .alphabets_with_space_only_pattern,
                                                message:
                                                    VALIDATIONS.alphabets_only,
                                            },
                                            {
                                                min: 3,
                                                message:
                                                    VALIDATIONS.name.min_length,
                                            },
                                            {
                                                max: 50,
                                                message:
                                                    VALIDATIONS.name.max_length,
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter your full name" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        name="email"
                                        label="Email Address"
                                        rules={[
                                            {
                                                type: 'email',
                                                message:
                                                    VALIDATIONS.email.not_valid,
                                            },
                                            {
                                                required: true,
                                                message:
                                                    VALIDATIONS.required_field,
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter your email address" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        name="organization"
                                        label="Organization (Optional)"
                                        rules={[
                                            {
                                                whitespace: true,
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter your organization name" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        name="subject"
                                        label="Subject"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please enter a subject.',
                                            },
                                            {
                                                min: 3,
                                                message:
                                                    'Subject must be at least 3 characters.',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter a short subject" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24}>
                                    <Form.Item
                                        name="description"
                                        label="Message"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please describe your issue or enquiry.',
                                            },
                                        ]}
                                    >
                                        <Input.TextArea
                                            rows={2}
                                            placeholder="Describe your issue or enquiry in detail..."
                                            maxLength={1000}
                                            showCount
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item className="submitRow">
                                <Button
                                    className="buttonSend"
                                    type="primary"
                                    htmlType="submit"
                                    icon={<SendOutlined />}
                                    loading={submitting}
                                >
                                    Submit Support Request
                                </Button>
                            </Form.Item>
                            <div className="supportHint">
                                Your information is secure and will only be used to
                                assist you.
                            </div>
                        </Form>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default Help
